import { FC, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet-async';

type PageTitleProps = {
  title: string;
};

export const PageTitle: FC<PageTitleProps> = ({ title }) => {
  const documentTitle = `${title} | Chirpee`;

  useLayoutEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);

  return (
    <Helmet defer={false}>
      <title>{documentTitle}</title>
    </Helmet>
  );
};
